export default __webpack_public_path__ + "static/media/beeple.ca500e64.png";